import { Stack, Text } from "@mantine/core";

const NoDataView = ({
  minHeight,
  bgcolor,
}: {
  minHeight?: number;
  bgcolor?: string;
}) => (
  <Stack
    justify="center"
    align="center"
    bg={bgcolor}
    mih={minHeight || 300}
    h="100%"
    w="100%"
  >
    <Text>No data available.</Text>
  </Stack>
);

export default NoDataView;
